<template>
  <VUEAppMenu :Titolo="TitoloPagina" :MenuAttuale="MenuAttuale" :SitoSelezionato="SitoSelezionatoHeader" :ListaSiti="MostraListaSitiInHeader ? ListaSiti : []" :CatenaSelezionata="IdAperta == IdPagine.VERTICALI_MODULABILI ? CatenaSelezionata : {}" :ListaCatene="IdAperta == IdPagine.VERTICALI_MODULABILI ? ListaCatene : []" @onSelezionaSito="OnSelezionaSito" @onSelezionaCatena="OnSelezionaCatena">
    <template v-slot:Content>
      <VUEAppContentDashboard v-if="IdAperta == IdPagine.DASHBOARD" ref="Dashboard" @onSitoCambiato="SitoSelezionato = $event"></VUEAppContentDashboard>
      <VUEVersioneDMSEW v-if="IdAperta == IdPagine.VERSIONE" :Altezza="Altezza"></VUEVersioneDMSEW>

      <VUEAppContentGestioneUtenti v-if="IdAperta == IdPagine.AMM_GESTIONE_UTENTI" :Altezza="Altezza"></VUEAppContentGestioneUtenti>
      <VUEAppContentGestioneMessaggi v-if="IdAperta == IdPagine.AMM_GESTIONE_MESSAGGI" :Altezza="Altezza"></VUEAppContentGestioneMessaggi>
      <VUEAppContentAggiungiMessaggio v-if="IdAperta == IdPagine.ADD_MESSAGGIO" :Altezza="Altezza"></VUEAppContentAggiungiMessaggio>
      <VUEAppContentSchedaMessaggi v-if="IdAperta == IdPagine.SCHEDA_MESSAGGI"></VUEAppContentSchedaMessaggi>
      <VUEAppContentGestioneSiti v-if="IdAperta == IdPagine.CFG_SITI"></VUEAppContentGestioneSiti>
      <VUEModificaSiti v-if="IdAperta == IdPagine.MODIFICA_SITI"></VUEModificaSiti>
      <VUEAppContentGraficiVerticali v-if="IdAperta == IdPagine.VERTICALI" :AltezzaPagina="Altezza" :ObjPresenzaMenu="ObjPresenzaMenu"></VUEAppContentGraficiVerticali>
      <VUEAppContentGraficiVerticaliModulabili v-if="IdAperta == IdPagine.VERTICALI_MODULABILI" ref="VerticaliModulabili" :AltezzaPagina="Altezza" :ObjPresenzaMenu="ObjPresenzaMenu" @onCatenaCambiata="OnCatenaCambiata" @onListaCateneCaricata="ListaCatene = $event"></VUEAppContentGraficiVerticaliModulabili>
      <VUEAppContentGraficiStorici v-if="IdAperta == IdPagine.STORICI" :AltezzaPagina="Altezza" :LarghezzaPagina="LarghezzaSchermo"></VUEAppContentGraficiStorici>
      <VUEAppContentRiassuntoAccelerometri v-if="IdAperta == IdPagine.RIASSUNTO_ACCELEROMETRI" :AltezzaPagina="Altezza" :LarghezzaPagina="LarghezzaSchermo"></VUEAppContentRiassuntoAccelerometri>
    </template>
  </VUEAppMenu>
</template>

<script>
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { SystemInformation, ID_PAGINE, RUOLI, TIPOLOGIA_GRAFICI_STORICI } from '@/SystemInformation';
import VUEAppMenu from '../components/Slots/VUEAppMenu.vue'
import VUEAppContentDashboard from '@/views/ContentPages/VUEAppContentDashboard.vue';
import VUEVersioneDMSEW from './ContentPages/VUEVersioneDMSEW.vue';

import VUEAppContentGestioneUtenti from './ContentPages/VUEAppContentGestioneUtenti.vue';
import VUEAppContentGestioneMessaggi from './ContentPages/VUEAppContentGestioneMessaggi.vue';
import VUEAppContentAggiungiMessaggio from './ContentPages/VUEAppContentAggiungiMessaggio.vue';
import VUEAppContentSchedaMessaggi from './ContentPages/VUEAppContentSchedaMessaggi.vue';
import VUEAppContentGestioneSiti from './ContentPages/VUEAppContentGestioneSiti.vue'
import VUEModificaSiti from './VUEModificaSiti.vue';

import VUEAppContentGraficiVerticali from './ContentPages/VUEAppContentGraficiVerticali.vue'
import VUEAppContentGraficiVerticaliModulabili from './ContentPages/VUEAppContentGraficiVerticaliModulabili.vue'
import VUEAppContentGraficiStorici from './ContentPages/VUEAppContentGraficiStorici.vue'
import VUEAppContentRiassuntoAccelerometri from './ContentPages/VUEAppContentRiassuntoAccelerometri.vue'
import { TZGenericFunct } from '@/utils/ZGenericFunct.js';

export default 
{
  mixins: [ MixInsGestioneTraduzioni ],
  data() 
    {
     return { 
              UserInformation        : SystemInformation.UserInformation,
              Altezza                : document.documentElement.clientHeight,
              LinguaUtente           : SystemInformation.UserInformation.Lingua,
              LarghezzaSchermo       : window.innerWidth,
              IdPagine               : ID_PAGINE,
              TipiStorici            : TIPOLOGIA_GRAFICI_STORICI,
              TitoloPagina           : '',
              // IdAperta == IdPagine                  : {
              //                             Dashboard              : false,
              //                             Opzioni                : false,
              //                             AmministrazioneEsporta : false,
              //                             VersioneDMSEW          : false, 

              //                             GestioneUtenti         : false,
              //                             GestioneMessaggi       : false,
              //                             AggiungiMessaggio      : false,
              //                             SchedaMessaggi         : false,
              //                             GestioneSiti           : false,

              //                             GraficiVerticali       : false
              //                           },
              IdAperta              : ID_PAGINE.DASHBOARD,
              SitoSelezionato       : {},
              ListaSiti             : [],
              CatenaSelezionata     : {},
              ListaCatene           : [],
              MenuAttuale           : [],              
              Admin                 : false,
              ObjPresenzaMenu       : {
                                        VisualizzaStazioneMeteo : false,
                                        CatenaSoloPiezo         : false,
                                      },
              MenuTrigger           : SystemInformation.MenuTrigger,
            };
    },
    components: 
    {
      VUEAppMenu,
      VUEAppContentDashboard,

      VUEVersioneDMSEW,

      VUEAppContentGestioneUtenti,
      VUEAppContentGestioneMessaggi,
      VUEAppContentAggiungiMessaggio,
      VUEAppContentSchedaMessaggi,
      VUEAppContentGestioneSiti,
      VUEModificaSiti,

      VUEAppContentGraficiVerticali,
      VUEAppContentGraficiVerticaliModulabili,
      VUEAppContentGraficiStorici,
      VUEAppContentRiassuntoAccelerometri
    },
    methods: 
    {
      getDimensions()
      {
        this.Altezza = document.documentElement.clientHeight
        this.LarghezzaSchermo = window.innerWidth
      },

      OnSelezionaSito(ChiaveSito)
      {
        if (this.$refs.Dashboard != null)
          this.$refs.Dashboard.ConfermaRicerca(ChiaveSito)
        else if (this.IdAperta == this.IdPagine.VERTICALI_MODULABILI)
          this.$router.push('/appMainWindow/Dashboard?ChiaveSito=' + ChiaveSito)
      },

      OnSelezionaCatena(ChiaveCatena)
      {
        if (this.$refs.VerticaliModulabili != null)
          this.$refs.VerticaliModulabili.CambiaCatena(ChiaveCatena)
      },

      OnCatenaCambiata(Catena)
      {
        this.CatenaSelezionata = Catena
      },

      AccelerometriPresenti()
      {
        let ParametriURL = TZGenericFunct.GetURLParameters()
        if (parseInt(ParametriURL.Accelerometri) > 0)
          return true
        return false
      },

      /*AllarmiPresenti()
      {
        let ParametriURL = TZGenericFunct.GetURLParameters()
        return ParametriURL.Allarmi == "true"
      },*/
      
      AggiornaTipoPagina()
      {
        this.TitoloPagina = ''
        this.MenuAttuale = []
        if(this.$route.params.pagina != 'Dashboard')
          this.MenuAttuale.push({
                                  DescFull    : 'Dashboard',
                                  DescShrink  : this.GetTraduzioneLabel('Generic','TKN_DASH',this.LinguaUtente),
                                  Id          : ID_PAGINE.DASHBOARD, 
                                  IconCfg     : "fa-dashboard", 
                                  Color       : "bg-info",
                                  ChildList   : []
                                })

        if (SystemInformation.UserInformation.Ruolo == RUOLI.Amministratore || SystemInformation.UserInformation.Ruolo == RUOLI.SuperUtente)
        {
          // ObjMenu.ChildList.push({
          //                           Descrizione : "Grafici storici",
          //                           Id          : ID_PAGINE.STORICI
          //                        })
          let ObjMenu = {
                      DescFull    : 'Amministrazione',
                      DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_MENU_AMM',this.LinguaUtente),
                      Id          : ID_PAGINE.AMM_GESTIONE, 
                      IconCfg     : "fa-user", 
                      Color       : "bg-warning",
                      ChildList   : [
                        {
                          Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_MENU_GESTIONE_SITI',this.LinguaUtente),
                          Id          : ID_PAGINE.CFG_SITI
                        },
                        {
                          Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_MENU_GESTIONE_UTENTI',this.LinguaUtente),
                          Id          : ID_PAGINE.AMM_GESTIONE_UTENTI
                        }
                      ]
                    }
          this.MenuAttuale.push(ObjMenu)
          
          // if (this.Admin)                                 
          //   ObjMenu.ChildList.push({
          //                             Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_MENU_GESTIONE_MESSAGGI',this.LinguaUtente),
          //                             Id          : ID_PAGINE.AMM_GESTIONE_MESSAGGI
          //                          })
          
          if (SystemInformation.UserInformation.Ruolo == RUOLI.Amministratore)
          {
            ObjMenu.ChildList.push({
                                        Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_MENU_GESTIONE_LINGUE',this.LinguaUtente),
                                        Id          : ID_PAGINE.AGGIORNA_LINGUE,
                                  })

            ObjMenu.ChildList.push({
                                      Descrizione    : (this.MenuTrigger.TriggerAbilitaSpostamento % 2 === 0) ? this.GetTraduzioneLabel('VUEGestionale','TKN_ABILITA_SPOST',this.LinguaUtente) : this.GetTraduzioneLabel('VUEGestionale','TKN_DISABILITA_SPOST',this.LinguaUtente),
                                      Id          : ID_PAGINE.ABILITA_SPOSTAMENTO, 
                                    })
          }
        }
                              
        switch (this.$route.params.pagina)
        {
          case 'Dashboard':
          {
            if (SystemInformation.UserInformation.Ruolo == RUOLI.Utente ||
                SystemInformation.UserInformation.Ruolo == RUOLI.Supervisore)
              this.MenuAttuale = []
              
            this.MenuAttuale.push({
                                    DescFull    : (this.MenuTrigger.TriggerMostraGrafici % 2 === 0) ? this.GetTraduzioneLabel('VUEGestionale','TKN_NASCONDI_POLARI',this.LinguaUtente) : this.GetTraduzioneLabel('VUEGestionale','TKN_MOSTRA_POL',this.LinguaUtente),
                                    DescShrink  : '',
                                    Id          : ID_PAGINE.MOSTRA_GRAFICI, 
                                    IconCfg     : "fa-dashboard", 
                                    Color       : "bg-info",
                                    ChildList   : []
                                  })
              
            this.MenuAttuale.push({
                                    DescFull    : (this.MenuTrigger.TriggerAllineaPolari % 2 === 0) ? this.GetTraduzioneLabel('VUEGestionale','TKN_ALLINEA_POLARI',this.LinguaUtente) : this.GetTraduzioneLabel('VUEGestionale','TKN_RIMUOVI_ALLINEAMENTO',this.LinguaUtente),
                                    DescShrink  : '',
                                    Id          : ID_PAGINE.ALLINEA_POLARI, 
                                    IconCfg     : "fa-dashboard", 
                                    Color       : "bg-info",
                                    ChildList   : []
                                  })
              
            this.MenuAttuale.push({
                                    DescFull    : this.GetTraduzioneLabel('VUEGestionale','TKN_ADD_GRAF_ABB',this.LinguaUtente),
                                    DescShrink  : '',
                                    Id          : ID_PAGINE.AGGIUNGI_ABBINATO, 
                                    IconCfg     : "fa-dashboard", 
                                    Color       : "bg-info",
                                    ChildList   : []
                                  })
              
            this.MenuAttuale.push({
                                    DescFull    : (this.MenuTrigger.TriggerMostraNascondiAllarmi % 2 === 0) ? this.GetTraduzioneLabel('VUEGestionale','TKN_MOSTRA_ALLARME',this.LinguaUtente) : this.GetTraduzioneLabel('VUEGestionale','TKN_NASCONDI_ALLARME',this.LinguaUtente),
                                    DescShrink  : '',
                                    Id          : ID_PAGINE.MOSTRA_NASCONDI_ALLARMI, 
                                    IconCfg     : "fa-dashboard", 
                                    Color       : "bg-info",
                                    ChildList   : []
                                  })
              
            this.MenuAttuale.push({
                                    DescFull    : this.GetTraduzioneLabel('VUEGestionale','TKN_MENU_CATENE',this.LinguaUtente),
                                    DescShrink  : '',
                                    Id          : ID_PAGINE.MENU_CATENE, 
                                    IconCfg     : "fa-dashboard", 
                                    Color       : "bg-info",
                                    ChildList   : []
                                  })

            this.IdAperta = ID_PAGINE.DASHBOARD
            break
          }
          case 'Opzioni' :
          {
            this.IdAperta = ID_PAGINE.OPZIONI
            this.TitoloPagina = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_IMPOSTAZIONI_GENERALI',this.LinguaUtente)
            break
          }
          case 'VersioneDMSEW' :
          {
            this.IdAperta = ID_PAGINE.VERSIONE
            this.TitoloPagina = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_VERSIONE_DMSEW',this.LinguaUtente)
            break
          }
          case 'GestioneUtenti' :
          {
            this.IdAperta = ID_PAGINE.AMM_GESTIONE_UTENTI
            this.TitoloPagina = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_GESTIONE_UTENTI',this.LinguaUtente)
            break
          }
          case 'GestioneMessaggi' :
          {
            this.IdAperta = ID_PAGINE.AMM_GESTIONE_MESSAGGI
            this.TitoloPagina = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_GESTIONE_MESSAGGI',this.LinguaUtente)
            break
          }
          case 'AggiungiMessaggio' :
          {
            this.IdAperta = ID_PAGINE.ADD_MESSAGGIO
            this.TitoloPagina = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_AGGIUNGI_MESSAGGIO',this.LinguaUtente)
            break
          }
          case 'SchedaMessaggi' :
          {
            this.IdAperta = ID_PAGINE.SCHEDA_MESSAGGI
            this.TitoloPagina = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_SCHEDA_MESSAGGI',this.LinguaUtente)
            break
          }
          case 'GestioneSiti' :
          {
            this.IdAperta = ID_PAGINE.CFG_SITI
            this.TitoloPagina = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_GESTIONE_SITI',this.LinguaUtente)
            break
          }
          case 'Sito' :
          {
            this.IdAperta = ID_PAGINE.MODIFICA_SITI
            this.TitoloPagina = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_SITO',this.LinguaUtente)
            break
          }
          case 'GraficiVerticali' :
          {
            this.MenuAttuale = []
            this.MenuAttuale.push({
                                    DescFull    : 'Dashboard',
                                    DescShrink  : this.GetTraduzioneLabel('Generic','TKN_DASH',this.LinguaUtente),
                                    Id          : ID_PAGINE.DASHBOARD, 
                                    IconCfg     : "fa-dashboard", 
                                    Color       : "bg-info",
                                    ChildList   : []
                                  })

            let ObjMenu = {
                            DescFull    : 'Dati storici',
                            DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STOR',this.LinguaUtente), 
                            // Id          : ID_PAGINE.STORICI, 
                            IconCfg     : "fa-clock-o", 
                            Color       : "bg-warning",
                            ChildList   : []
                          }
            this.MenuAttuale.push(ObjMenu)
            ObjMenu.ChildList.push({
                                      Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_RILEVATI',this.LinguaUtente),
                                      Id          : ID_PAGINE.POPUP_CAMPIONI_RILEVATI
                                  })
            if(this.ObjPresenzaMenu.VisualizzaStazioneMeteo)
              ObjMenu.ChildList.push({
                                        Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STAZIONE_METEO',this.LinguaUtente),
                                        Id          : ID_PAGINE.POPUP_STAZIONE_METEO
                                    })
            
            let ObjMenuChild = {
                                  Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ACCEL',this.LinguaUtente),
                                  ChildList   : []
                              } 

            if (this.AccelerometriPresenti())
            {
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_LS_SUP_SOGLIA',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_SS,
                                          })
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_CRONOLOGIA_EVENTI',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_CE,
                                          })
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_AMPIEZZA_XYZ',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_A,
                                          })
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_FREQ_MODULO',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_F,
                                          })
              ObjMenu.ChildList.push(ObjMenuChild)
            }

            ObjMenuChild = {
                              Descrizione : this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTI',this.LinguaUtente),
                              ChildList   : []
                           } 
            ObjMenu.ChildList.push(ObjMenuChild)
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_GRAFICI_SEPARATI',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_SPOSTAMENTO_GRAF_SEPARATI,
                                        })
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_GRAFICI_SOVRAPPOSTI',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_SPOSTAMENTO_GRAF_SOVR,
                                        })


            ObjMenuChild = {
                              Descrizione : this.GetTraduzioneLabel('Generic','TKN_VELOCITA',this.LinguaUtente),
                              ChildList   : []
                            } 
            ObjMenu.ChildList.push(ObjMenuChild)
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_VEL_MEDIA_ORARIA',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_VELOCITA_MEDIA_ORARIA,
                                        })
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_VEL_MEDIA_GIORNALIERA',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_VELOCITA_MEDIA_GIORNALIERA,
                                        })


            ObjMenuChild = {
                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ACCELERAZIONE',this.LinguaUtente),
                              ChildList   : []
                            } 
            ObjMenu.ChildList.push(ObjMenuChild)
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ACCEL_MEDIA_ORARIA',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_ACCELERAZIONE_MEDIA_ORARIA,
                                        })
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ACCEL_MEDIA_GIORNALIERA',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_ACCELERAZIONE_MEDIA_GIORNALIERA,
                                        })


            ObjMenu.ChildList.push({
                                      Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_TENSIONE_ALIM',this.LinguaUtente),
                                      Id          : ID_PAGINE.POPUP_TENSIONE_ALIMENTAZIONE
                                  })
            ObjMenu.ChildList.push({
                                      Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ASSORB',this.LinguaUtente),
                                      Id          : ID_PAGINE.POPUP_ASSORBIMENTO
                                  })
            ObjMenu           = {
                                  DescFull    : 'Esporta',
                                  DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_MOD_GRAF',this.LinguaUtente),
                                  IconCfg     : "fa-folder",
                                  Color       : "bg-danger",
                                  ChildList   : []
                                }   
            this.MenuAttuale.push(ObjMenu)
            ObjMenu.ChildList.push({
                                          DescFull    : 'Esporta xlsx',
                                          DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_EXPORT_DATI',this.LinguaUtente),
                                          Id          : ID_PAGINE.ESPORTAZIONE_XLSX, 
                                          IconCfg     : "fa-file-excel-o", 
                                          Color       : "bg-success",
                                          ChildList   : []
                                        })
            ObjMenu.ChildList.push({
                                          DescFull    : 'Esporta PDF',
                                          DescShrink : this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente),
                                          Id          : ID_PAGINE.ESPORTA_PDF,
                                          IconCfg     : "fa-file-pdf-o", 
                                          Color       : "#ff0000",
                                          ChildList   : []
                                        })
            this.IdAperta = ID_PAGINE.VERTICALI
            break
          }
          case 'GraficiVerticaliModulabili' :
          {
            this.MenuAttuale = []
            
            let ObjMenu = {
                            DescFull    : 'Menu allarmi',
                            DescShrink  : this.GetTraduzioneLabel('Generic','TKN_MENU_ALLARMI',this.LinguaUtente),
                            Id          : ID_PAGINE.MENU_ALLARMI, 
                            IconCfg     : "fa-exclamation-triangle blinking", 
                            Color       : "bg-danger",
                            ChildList   : []
                          }
            this.MenuAttuale.push(ObjMenu)    

            ObjMenu = {
                            DescFull    : 'Dashboard',
                            DescShrink  : this.GetTraduzioneLabel('Generic','TKN_DASH',this.LinguaUtente),
                            Id          : ID_PAGINE.DASHBOARD, 
                            IconCfg     : "fa-dashboard", 
                            Color       : "bg-info",
                            ChildList   : []
                          }
            this.MenuAttuale.push(ObjMenu)   

            ObjMenu = {
                        DescFull    : 'Dati storici',
                        DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STOR',this.LinguaUtente), 
                        // Id          : ID_PAGINE.STORICI, 
                        IconCfg     : "fa-clock-o", 
                        Color       : "bg-warning",
                        ChildList   : []
                      }
            this.MenuAttuale.push(ObjMenu)
            ObjMenu.ChildList.push({
                                      Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_RILEVATI',this.LinguaUtente),
                                      Id          : ID_PAGINE.POPUP_CAMPIONI_RILEVATI
                                  })
            if(this.ObjPresenzaMenu.VisualizzaStazioneMeteo)
              ObjMenu.ChildList.push({
                                        Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STAZIONE_METEO',this.LinguaUtente),
                                        Id          : ID_PAGINE.POPUP_STAZIONE_METEO
                                    })
            let ObjMenuChild = null

            if (this.AccelerometriPresenti())
            {
              ObjMenuChild = {
                                Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ACCEL',this.LinguaUtente),
                                ChildList   : []
                              }

              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_LS_SUP_SOGLIA',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_SS,
                                          })
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_CRONOLOGIA_EVENTI',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_CE,
                                          })
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_AMPIEZZA_XYZ',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_A,
                                          })
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_FREQ_MODULO',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_EVENTI_ACCELEROMETRICI_F,
                                          })
              ObjMenu.ChildList.push(ObjMenuChild)
            }
            
            ObjMenuChild = {
                              Descrizione : this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTI',this.LinguaUtente),
                              ChildList   : []
                           } 
            ObjMenu.ChildList.push(ObjMenuChild)
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_GRAFICI_SEPARATI',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_SPOSTAMENTO_GRAF_SEPARATI,
                                        })
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_GRAFICI_SOVRAPPOSTI',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_SPOSTAMENTO_GRAF_SOVR,
                                        })


            ObjMenuChild = {
                              Descrizione : this.GetTraduzioneLabel('Generic','TKN_VELOCITA',this.LinguaUtente),
                              ChildList   : []
                            } 
            ObjMenu.ChildList.push(ObjMenuChild)
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_VEL_MEDIA_ORARIA',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_VELOCITA_MEDIA_ORARIA,
                                        })
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_VEL_MEDIA_GIORNALIERA',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_VELOCITA_MEDIA_GIORNALIERA,
                                        })


            ObjMenuChild = {
                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ACCELERAZIONE',this.LinguaUtente),
                              ChildList   : []
                            } 
            ObjMenu.ChildList.push(ObjMenuChild)
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ACCEL_MEDIA_ORARIA',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_ACCELERAZIONE_MEDIA_ORARIA,
                                        })
            ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ACCEL_MEDIA_GIORNALIERA',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_ACCELERAZIONE_MEDIA_GIORNALIERA,
                                        })


            ObjMenu.ChildList.push({
                                      Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_TENSIONE_ALIM',this.LinguaUtente),
                                      Id          : ID_PAGINE.POPUP_TENSIONE_ALIMENTAZIONE
                                  })
            ObjMenu.ChildList.push({
                                      Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ASSORB',this.LinguaUtente),
                                      Id          : ID_PAGINE.POPUP_ASSORBIMENTO
                                  })
            ObjMenu             = {
                                    DescFull    : 'Esporta dati',
                                    DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_EXPORT_DATI',this.LinguaUtente),
                                    // Id          : ID_PAGINE.ESPORTAZIONE_XLSX, 
                                    IconCfg     : "fa-copy", 
                                    Color       : "bg-export",
                                    ChildList   : []
                                  }
            this.MenuAttuale.push(ObjMenu)
            ObjMenu.ChildList.push({
                                      Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_ESPORTA_XLSX',this.LinguaUtente),
                                      Id          : ID_PAGINE.ESPORTAZIONE_XLSX
                                    })                                              
            ObjMenu.ChildList.push({
                                    Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_ESPORTA_PDF',this.LinguaUtente),
                                    Id          : ID_PAGINE.ESPORTA_PDF
                                  })
            
            ObjMenuChild        = {
                                    Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_ESPORTA_XLSX_STORICI',this.LinguaUtente),
                                    ChildList   : []
                                  }
            ObjMenu.ChildList.push(ObjMenuChild)
            ObjMenuChild.ChildList.push({
                                          Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_ESPORTA_XLSX_CAMPIONI_RILEVATI',this.LinguaUtente),
                                          Id          : ID_PAGINE.ESPORTA_XLSX_CAMPIONI_RILEVATI
                                        })
            ObjMenuChild.ChildList.push({
                                          Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_ESPORTA_XLSX_SPOSTAMENTI',this.LinguaUtente),
                                          Id          : ID_PAGINE.ESPORTA_XLSX_SPOSTAMENTI
                                        })
            ObjMenu             = {
                                    DescFull    : 'Modifiche grafiche',
                                    DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_MOD_GRAF',this.LinguaUtente),
                                    IconCfg     : "fa-folder",
                                    Color       : "bg-danger",
                                    ChildList   : []
                                  }   
            if(!this.ObjPresenzaMenu.CatenaSoloPiezo)
            {
              this.MenuAttuale.push(ObjMenu)     
              ObjMenu.ChildList.push({
                                        Descrizione : this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_ADATTA_GRAF',this.LinguaUtente),
                                        Id          : ID_PAGINE.ADATTA_GRAFICI
                                      })   
              // ObjMenu.ChildList.push({
              //                           Descrizione : this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente),
              //                           Id          : ID_PAGINE.ESPORTA_PDF
              //                         })   
              // ObjMenu.ChildList.push({
              //                           Descrizione : (this.MenuTrigger.TriggerDifferenziale % 2 === 0) ? this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_DIFF',this.LinguaUtente) : this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_CUM',this.LinguaUtente),
              //                           Id          : ID_PAGINE.SPOST_DIFFERENZIALE
              //                         })  
              ObjMenu.ChildList.push({
                                        Descrizione : (this.MenuTrigger.ApriPopupMediaAritmetica % 2 === 0) ? this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MEDIA_ARIT',this.LinguaUtente) : this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_RIMUOVI_MEDIA',this.LinguaUtente),
                                        Id          : ID_PAGINE.MEDIA_ARITMETICA
                                      })   
              ObjMenu.ChildList.push({
                                        Descrizione : this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_CAMBIA_SCALE',this.LinguaUtente),
                                        Id          : ID_PAGINE.CAMBIA_SCALE
                                      })   
              ObjMenu.ChildList.push({
                                        Descrizione : this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MASSIMIZZA',this.LinguaUtente),
                                        Id          : ID_PAGINE.MASSIMIZZA
                                      })
                                      
               this.MenuAttuale.push({
                                        DescFull    : (this.MenuTrigger.TriggerDifferenziale % 2 === 0) ? this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_DIFF',this.LinguaUtente) : this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_CUM',this.LinguaUtente),
                                        DescShrink  : (this.MenuTrigger.TriggerDifferenziale % 2 === 0) ? this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_DIFF',this.LinguaUtente) : this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_SPOST_CUM',this.LinguaUtente),
                                        Id          : ID_PAGINE.SPOST_DIFFERENZIALE,
                                        IconCfg     : "fa-bell", 
                                        Color       : "bg-danger",
                                        ChildList   : []
                                    })
            }
                                  
            if(this.Admin)   
            {
              let ObjMenu = {
                                    DescFull    : 'Amministratore',
                                    DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_MENU_AMM',this.LinguaUtente),
                                    IconCfg     : "fa-user", 
                                    Color       : "bg-primary",
                                    ChildList   : []
                                  }   
              this.MenuAttuale.push(ObjMenu)     
              ObjMenu.ChildList.push({
                                        Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_MENU_MODULA_GRAFICI',this.LinguaUtente),
                                        Id          : ID_PAGINE.MODULAZIONE_GRAFICI
                                      })
            }

            this.IdAperta = ID_PAGINE.VERTICALI_MODULABILI
            break
          }
          case 'GraficiStorici' :
          {
            this.MenuAttuale = []
            this.MenuAttuale.push({
                                    DescFull    : 'Dashboard',
                                    DescShrink  : this.GetTraduzioneLabel('Generic','TKN_DASH',this.LinguaUtente),
                                    Id          : ID_PAGINE.DASHBOARD, 
                                    IconCfg     : "fa-dashboard", 
                                    Color       : "bg-info",
                                    ChildList   : []
                                  })
            if(SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.CAMPIONI_RILEVATI ||
               SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SEPARATI ||
               SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_ORARIA ||
               SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_GIORNALIERA ||
               SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_ORARIA ||
               SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_GIORNALIERA
              )
            {
              let ObjMenuChild = {
                                      DescFull    : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STORICI_ALLINEAMENTO',this.LinguaUtente),
                                      DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STORICI_ALL',this.LinguaUtente),
                                      IconCfg     : "fa-clock-o", 
                                      Color       : "bg-success",
                                      ChildList   : []
                                    }
  
              this.MenuAttuale.push(ObjMenuChild)
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STORICI_ASSEX',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_X,
                                          })
              if (SystemInformation.TipoPopupAperto != TIPOLOGIA_GRAFICI_STORICI.CAMPIONI_RILEVATI)
              {
                ObjMenuChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STORICI_ASSEY',this.LinguaUtente),
                                              Id          : ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_Y,
                                            })
              }
              else
              {
                ObjMenuChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STORICI_ASSE_INCLINOMETRI',this.LinguaUtente),
                                              Id          : ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_INCLINOMETRI,
                                            })
                ObjMenuChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STORICI_ASSE_PIEZOMETRI',this.LinguaUtente),
                                              Id          : ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_PIEZOMETRI,
                                            })
                ObjMenuChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STORICI_ASSE_ESTENSIMETRI',this.LinguaUtente),
                                              Id          : ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_ESTENSIMETRI,
                                            })

              }
  
              if(SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.CAMPIONI_RILEVATI)
                ObjMenuChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STORICI_TEMP',this.LinguaUtente),
                                              Id          : ID_PAGINE.POPUP_ALLINEAMENTO_ASSE_TEMP,
                                            })

              
              if(SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_GIORNALIERA)
              {
              let ObjMenuChild = {
                                      DescFull    : 'Imposta allarmi',
                                      DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STORICI_ALLARMI',this.LinguaUtente),
                                      Id          : ID_PAGINE.POPUP_IMPOSTA_ALLARMI,
                                      IconCfg     : "fa-bell", 
                                      Color       : "bg-danger",
                                      ChildList   : []
                                    }

              this.MenuAttuale.push(ObjMenuChild)
              }
            }          

            if (SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SUP_SOGLIE)
            {              
              let ObjMenuChild    = {
                                      DescFull    : this.GetTraduzioneLabel('VUEGestionale','TKN_SCALE',this.LinguaUtente),
                                      DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_SCALE',this.LinguaUtente),
                                      IconCfg     : "fa-clock-o", 
                                      Color       : "bg-success",
                                      ChildList   : []
                                    }
              this.MenuAttuale.push(ObjMenuChild)

              let ObjMenuSubChild = {
                                      Descrizione    : this.GetTraduzioneLabel('VUEGestionale','TKN_RIGHELLI',this.LinguaUtente),
                                      ChildList   : []
                                    }      
              ObjMenuChild.ChildList.push(ObjMenuSubChild)
              ObjMenuSubChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente),
                                              Id          : ID_PAGINE.AGGIUNGI_RIGHELLO_ACCELEROMETRI,
                                            })
              ObjMenuSubChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_ELIMINA',this.LinguaUtente),
                                              Id          : ID_PAGINE.ELIMINA_RIGHELLO_ACCELEROMETRI,
                                            })

              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_SCALE_ASSE_X',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_SCALA_GRAPH_X,
                                          })
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_SCALE_ASSE_Y',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_SCALA_GRAPH_Y,
                                          })
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_SCALE_ASSE_Z',this.LinguaUtente),
                                            Id          : ID_PAGINE.POPUP_SCALA_GRAPH_Z,
                                          })
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('Generic','TKN_ADATTA',this.LinguaUtente),
                                            Id          : ID_PAGINE.ADATTA_GRAFICI,
                                          })
              
              ObjMenuChild        = {
                                      DescFull    : this.GetTraduzioneLabel('VUEGestionale','TKN_ESPORTAZIONE',this.LinguaUtente),
                                      DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_ESPORTAZIONE',this.LinguaUtente),
                                      IconCfg     : "fa-clock-o", 
                                      Color       : "bg-success",
                                      ChildList   : []
                                    }
              this.MenuAttuale.push(ObjMenuChild)              
                                          
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente),
                                            Id          : ID_PAGINE.ESPORTA_PDF,
                                          })              
                                          
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_EXP_FILE',this.LinguaUtente),
                                            Id          : ID_PAGINE.ESPORTAZIONE_XLSX,
                                          })
            }
            
            if (SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A ||
                SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_F)
            {
              this.MenuAttuale.push({
                                       DescFull    : this.GetTraduzioneLabel('VUEGestionale','TKN_SCALE_ASSE_X',this.LinguaUtente),
                                       DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_SCALE_ASSE_X',this.LinguaUtente),
                                       Id          : ID_PAGINE.POPUP_SCALA_X,
                                       IconCfg     : "fa-bell", 
                                       Color       : "bg-danger",
                                       ChildList   : []
                                   })
              this.MenuAttuale.push({
                                       DescFull    : this.GetTraduzioneLabel('VUEGestionale','TKN_SCALE_ASSE_Y',this.LinguaUtente),
                                       DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_SCALE_ASSE_Y',this.LinguaUtente),
                                       Id          : ID_PAGINE.POPUP_SCALA_Y,
                                       IconCfg     : "fa-bell", 
                                       Color       : "bg-danger",
                                       ChildList   : []
                                   })

              if(SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A)                 
              {                
                let ObjMenuSoglie = {
                                        DescFull    : this.GetTraduzioneLabel('VUEGestionale','TKN_SOGLIE_RILEVAMENTO',this.LinguaUtente),
                                        DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_SOGLIE_RILEVAMENTO',this.LinguaUtente),
                                        IconCfg     : "fa-clock-o", 
                                        Color       : "bg-success",
                                        ChildList   : []
                                      }
    
                this.MenuAttuale.push(ObjMenuSoglie)

                ObjMenuSoglie.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_MOSTRA',this.LinguaUtente),
                                              Id          : ID_PAGINE.MOSTRA_SOGLIE_RILEVAMENTO,
                                            })
                ObjMenuSoglie.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_NASCONDI',this.LinguaUtente),
                                              Id          : ID_PAGINE.NASCONDI_SOGLIE_RILEVAMENTO,
                                            })
              }

              let ObjMenuChild    = {
                                      DescFull    : this.GetTraduzioneLabel('VUEGestionale','TKN_CAMBIA_COLORI',this.LinguaUtente),
                                      DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_CAMBIA_COLORI',this.LinguaUtente),
                                      IconCfg     : "fa-clock-o", 
                                      Color       : "bg-success",
                                      ChildList   : []
                                    }
    
              this.MenuAttuale.push(ObjMenuChild)

              if(SystemInformation.TipoPopupAperto == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A)
              {
                ObjMenuChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_AMPIEZZA_ASSE_X',this.LinguaUtente),
                                              Id          : ID_PAGINE.POPUP_COLORE_AMPIEZZA_ASSE_X,
                                            })
                ObjMenuChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_AMPIEZZA_ASSE_Y',this.LinguaUtente),
                                              Id          : ID_PAGINE.POPUP_COLORE_AMPIEZZA_ASSE_Y,
                                            })
                ObjMenuChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_AMPIEZZA_ASSE_Z',this.LinguaUtente),
                                              Id          : ID_PAGINE.POPUP_COLORE_AMPIEZZA_ASSE_Z,
                                            })
              }
              else
              {
                ObjMenuChild.ChildList.push({
                                              Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_FREQUENZA',this.LinguaUtente),
                                              Id          : ID_PAGINE.POPUP_COLORE_FREQUENZA,
                                            })
              }
                                
              ObjMenuChild = {
                                      DescFull    : this.GetTraduzioneLabel('VUEGestionale','TKN_RIGHELLI',this.LinguaUtente),
                                      DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_RIGHELLI',this.LinguaUtente),
                                      IconCfg     : "fa-clock-o", 
                                      Color       : "bg-success",
                                      ChildList   : []
                                    }
  
              this.MenuAttuale.push(ObjMenuChild)

              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente),
                                            Id          : ID_PAGINE.AGGIUNGI_RIGHELLO_ACCELEROMETRI,
                                          })
              ObjMenuChild.ChildList.push({
                                            Descrizione : this.GetTraduzioneLabel('VUEGestionale','TKN_ELIMINA',this.LinguaUtente),
                                            Id          : ID_PAGINE.ELIMINA_RIGHELLO_ACCELEROMETRI,
                                          })

            }
            this.MenuAttuale.push({
                                    DescFull    : 'Torna alla catena',
                                    DescShrink  : this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_STORICI_CATENA',this.LinguaUtente),
                                    Id          : ID_PAGINE.TORNA_ALLA_CATENA, 
                                    IconCfg     : "fa-reply", 
                                    Color       : "bg-danger",
                                    ChildList   : []
                                  })

            // this.MenuAttuale.push({
            //                         DescFull    : 'Esporta dati',
            //                         DescShrink  : 'Esporta',
            //                         Id          : ID_PAGINE.ESPORTAZIONE_XLSX, 
            //                         IconCfg     : "fa-file-excel-o", 
            //                         Color       : "bg-success",
            //                         ChildList   : []
            //                       })
            this.IdAperta = ID_PAGINE.STORICI
            break
          }
          case 'Sinottico' :
          {
            this.MenuAttuale = []
            this.MenuAttuale.push({
                                    DescFull    : 'Dashboard',
                                    DescShrink  : this.GetTraduzioneLabel('Generic','TKN_DASH',this.LinguaUtente),
                                    Id          : ID_PAGINE.DASHBOARD, 
                                    IconCfg     : "fa-dashboard", 
                                    Color       : "bg-info",
                                    ChildList   : []
                                  })
            this.IdAperta = ID_PAGINE.RIASSUNTO_ACCELEROMETRI
            break
          }
        }
        // this.IdAperta == IdPagine.Dashboard =  this.$route.params.pagina == 'Dashboard';

        // this.IdAperta == IdPagine.Opzioni =  this.$route.params.pagina == 'Opzioni';
        // if(this.IdAperta == IdPagine.Opzioni) this.TitoloPagina = 'Impostazioni generali';
        // this.IdAperta == IdPagine.VersioneDMSEW =  this.$route.params.pagina == 'VersioneDMSEW';
        // if(this.IdAperta == IdPagine.VersioneDMSEW) this.TitoloPagina = 'Versione DMSEW';
        // this.IdAperta == IdPagine.GestioneUtenti = this.$route.params.pagina == 'GestioneUtenti';
        // if(this.IdAperta == IdPagine.GestioneUtenti) this.TitoloPagina = 'Gestione Utenti';
        // this.IdAperta == IdPagine.GestioneMessaggi = this.$route.params.pagina == 'GestioneMessaggi';
        // if(this.IdAperta == IdPagine.GestioneMessaggi) this.TitoloPagina = 'Gestione Messaggi';
        // this.IdAperta == IdPagine.AggiungiMessaggio = this.$route.params.pagina == 'AggiungiMessaggio';
        // if(this.IdAperta == IdPagine.AggiungiMessaggio) this.TitoloPagina = 'Aggiungi Messaggio';
        // this.IdAperta == IdPagine.SchedaMessaggi = this.$route.params.pagina == 'SchedaMessaggi';
        // if(this.IdAperta == IdPagine.SchedaMessaggi) this.TitoloPagina = 'Scheda Messaggi';
        // this.IdAperta == IdPagine.GestioneSiti = this.$route.params.pagina == 'GestioneSiti'
        // if (this.IdAperta == IdPagine.GestioneSiti) this.TitoloPagina = 'Gestione Siti'
        // this.IdAperta == IdPagine.GraficiVerticali =  this.$route.params.pagina == 'GraficiVerticali';
        // if(this.IdAperta == IdPagine.Opzioni) this.TitoloPagina = 'Grafici verticali';
      }
    },
    computed:
    {
      MostraListaSitiInHeader()
      {
        return this.IdAperta == this.IdPagine.DASHBOARD
          || this.IdAperta == this.IdPagine.VERTICALI_MODULABILI
      },

      SitoSelezionatoHeader()
      {
        if (this.IdAperta == this.IdPagine.DASHBOARD)
          return this.SitoSelezionato

        if (this.IdAperta == this.IdPagine.VERTICALI_MODULABILI)
        {
          let ParametriURL = TZGenericFunct.GetURLParameters()
          if (ParametriURL.ChiaveSito != undefined)
          {
            let Sito = this.ListaSiti.find((element) => { return element.CHIAVE == ParametriURL.ChiaveSito })
            return Sito != null ? Sito : {}
          }
        }

        return {}
      },
    },
    watch:
    {
      MenuTrigger:
      {
        handler()
        {
          this.AggiornaTipoPagina()
        },
        deep : true
      },

      ObjPresenzaMenu:
      {
        handler()
        {
          this.AggiornaTipoPagina()
        },
        deep : true
      }
    },
    beforeMount()
    {
      this.Admin = SystemInformation.UserInformation.Ruolo == RUOLI.Amministratore
      this.ListaSiti = SystemInformation.Configurazioni.Siti
      this.ObjPresenzaMenu.VisualizzaStazioneMeteo = false
      this.ObjPresenzaMenu.CatenaSoloPiezo         = false
      this.AggiornaTipoPagina();
    },
    beforeUpdate()
    {
      this.AggiornaTipoPagina();
    },
    mounted() 
    {
      window.addEventListener('resize', this.getDimensions)
    },
    unmounted() 
    {
      window.removeEventListener('resize', this.getDimensions);
    },
};
</script>

<style scoped>
  .dropdown-menu {
    display: block;
  }
</style>